import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = ({ onBookNow }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        setIsScrolled(window.scrollY > 50);
        ticking = false;
      });
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-md py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className={`text-sm md:text-base font-['Montserrat'] font-light tracking-[0.3em] uppercase ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              Sagar Sen Photography
            </h1>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('albums')}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Albums
            </button>
            <button
              onClick={() => scrollToSection('videos')}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Videos
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('blog')}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Blog
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium hover:opacity-70 transition-opacity text-base ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Contact
            </button>
            <Button
              onClick={onBookNow}
              className={`${
                isScrolled
                  ? 'bg-gray-900 hover:bg-gray-800 text-white'
                  : 'bg-white hover:bg-gray-100 text-gray-900'
              } px-6 py-2`}
            >
              Book Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <button
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setIsMobileMenuOpen(false);
              }}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('albums')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Albums
            </button>
            <button
              onClick={() => scrollToSection('videos')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Videos
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('blog')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Blog
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`block w-full text-left font-medium ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              Contact
            </button>
            <Button
              onClick={() => {
                onBookNow();
                setIsMobileMenuOpen(false);
              }}
              className="w-full bg-gray-900 hover:bg-gray-800 text-white"
            >
              Book Now
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
